dispatcher.listenTo(dispatcher, 'heightEqualizer:reset', function () {
  heightEqualizer.reset();
});

export const heightEqualizer = {
  init(handleInvisibleElements = true) {
    heightEqualizer.heightEqualizer(handleInvisibleElements);
    resize.addToFunctionList(heightEqualizer.reset, true, handleInvisibleElements);
  },
  heightEqualizer(handleInvisibleElements = true, targetSelector = '.api_heightEqualizer', useDelay = 2000) {
    $(targetSelector).each((_index, obj) => {
      const devicesList = typeof $(obj).data('deviceslist') !== 'undefined' ? $(obj).data('deviceslist') : 'all';
      const doResize = devicesList === 'all' || (devicesList.indexOf('mobile') > -1 && DEVICE.isMobile) || (devicesList.indexOf('tablet') > -1 && DEVICE.isTablet) || (devicesList.indexOf('desktop') > -1 && DEVICE.isDesktop);

      if (doResize) {
        //on ajoute un time out pour laisser le temps au contenu de s'afficher dans la page
        setTimeout(() => {
          heightEqualizer.equalize(obj, handleInvisibleElements);
        }, useDelay);
      }
    });
  },
  equalize(obj, handleInvisibleElements) {
    const cssRowSelector = typeof $(obj).data('selector') !== 'undefined' ? $(obj).data('selector') : '.api_heightEqualizer-row';

    let parentHidden = '';
    let maxHeight = 0;
    let rowList = $(obj).find(cssRowSelector);

    //memorize the equalize initiation
    $(obj).data('height_equalizer_initiated', 1);

    rowList.each(function (_i, rowElement) {
      //si l'objet est caché, on le rend invisible au lieu de caché pour calculer sa hauteur
      if (handleInvisibleElements && $(rowElement).not(':visible') && parentHidden === '') {
        parentHidden = $(rowElement).parents().filter(function () {
          return $(this).css('display') === 'none';
        }).first();

        $(parentHidden).css('visibility', 'hidden');
        $(parentHidden).css('display', 'block');
      }

      if ($(rowElement)[0].offsetHeight > maxHeight && !$(rowElement).hasClass('api_heightEqualizer-ignore')) {
        maxHeight = $(rowElement)[0].offsetHeight;
      }
    });

    if (maxHeight > 0) {
      rowList.css('height', maxHeight);
    }

    //si nécessaire on remet le parent dans son état initial
    if (parentHidden !== '') {
      $(parentHidden).css('visibility', 'visible');
      $(parentHidden).css('display', 'none');
    }
  },
  reset(useDelay = 2000, handleInvisibleElements = true) {
    $('.api_heightEqualizer').each(function (_index, obj) {
      if (typeof $(obj).data('height_equalizer_initiated') !== 'undefined' && $(obj).data('height_equalizer_initiated') === 1) {
        const cssRowSelector = typeof $(obj).data('selector') !== 'undefined' ? $(obj).data('selector') : '.api_heightEqualizer-row';

        $(cssRowSelector).css('height', 'auto');
        $(obj).data('height_equalizer_initiated', 0);
      }
    });

    heightEqualizer.heightEqualizer(handleInvisibleElements, '.api_heightEqualizer', useDelay);
  }
};